import { StateTagType } from '@shared/ui-components/state-tag/models/tag.model';
import { ClientType } from '@core/domain/model/user/auth-user.model';
import { StringIdName } from '@core/domain/model/master/string-id-name.model';

export type IndividualInstallation = {
  numeroContrato: string;
  titular: string;
  fechaAlta: Date;
  fechaFin: Date;
  estadoContrato: string;
  estadoContratoTag: StateTagType;
  estadoContratoCodigo: InstallationStatusCode;
  idDctmContrato: string;
  idDctmSepa: string;
  codigoInstalacion: string;
  nombreInstalacion: string;
  cups: string;
  nombreRazonSocial: string;
  codigoRazonSocial: string;
  tarifa: string;
  consumoEstimadoAnual: number;
  potenciasP1: number;
  potenciasP2: number;
  potenciasP3: number;
  potenciasP4: number;
  potenciasP5: number;
  potenciasP6: number;
  consumosP1: number;
  consumosP2: number;
  consumosP3: number;
  consumosP4: number;
  consumosP5: number;
  consumosP6: number;
  direccion: string;
  codPostal: string;
  poblacion: string;
  municipio: string;
  provincia: string;
  apellidos: string;
  telefono: string;
  nombreContacto: string;
  email: string;
  invoiceRoadTypeCode: string;
  invoiceRoadType: string;
  invoiceDirection: string;
  invoiceNumber: string;
  invoicePortal: string;
  invoiceStairs: string;
  invoiceFloor: string;
  invoiceDoor: string;
  invoicePostal: string;
  invoiceTownCode: string;
  invoiceTown: string;
  invoiceProvince: string;
  invoiceProvinceCode: string;
  invoiceMunicipality: string;
  invoiceMunicipalityCode: string;
  clientType: ClientType;
  iban: string;
  entity: string;
  branch: string;
  dc: string;
  account: string;
  sepaCode: string;
  portugalCycle: string;
  portugalTension: string;
  portugalTensionDescription: string;
  portugalPeriod: string;
  portugalPeriodDescription: string;
  portugalPower: number;
};

export enum InstallationStatusCode {
  REJECTED = '100000000',
  PRE_CONTRACT = '300000000',
  PENDING_DATA = '300000001',
  PENDING_SWITCH = '300000002',
  REQUESTED = '300000003',
  CANCELLED = '300000004',
  FORMALIZED = '300000005',
  FORMALIZED_ACCEPTED = '300000006',
  FORMALIZED_REJECTED = '300000007',
  FINALIZED = '300000011',
}

export const portugalInstallationTensions: StringIdName[] = [
  { id: 'AT', name: 'BASE.TENSIONS.AT' },
  { id: 'BT', name: 'BASE.TENSIONS.BT' },
  { id: 'HT', name: 'BASE.TENSIONS.HT' },
  { id: 'MT', name: 'BASE.TENSIONS.MT' },
];

export function portugalTensionName(tension: string) {
  return portugalInstallationTensions.find((value) => value.id === tension)?.name ?? tension;
}

export const portugalInstallationPeriods: StringIdName[] = [
  { id: '0', name: 'BASE.PERIODS.0' },
  { id: '1', name: 'BASE.PERIODS.1' },
  { id: '2', name: 'BASE.PERIODS.2' },
  { id: '3', name: 'BASE.PERIODS.3' },
  { id: '4', name: 'BASE.PERIODS.4' },
];

export function portugalPeriodName(period: string) {
  return portugalInstallationPeriods.find((value) => value.id === period)?.name ?? period;
}
